module.exports = __webpack_public_path__ + "static/media/login-bg.5ee6fee0.svg";